import { render } from "./Drawer.vue?vue&type=template&id=a9971e38&ts=true"
import script from "./Drawer.ts?vue&type=script&lang=ts&external"
export * from "./Drawer.ts?vue&type=script&lang=ts&external"

import "./Drawer.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer});
